import { isoDateTimeSchema } from "@inrev/common";
import * as z from "zod";
import { EvidenceId } from "./evidence";

export const truncatedSchema = z.strictObject({
	shown: z.number().int().nonnegative(),
	total: z.number().int().nonnegative(),
});

export const toolEnvelope = <TData extends z.ZodType>(data: TData) =>
	z.strictObject({
		data,
		evidence: z.array(EvidenceId.schema),
		asOf: isoDateTimeSchema,
		truncated: truncatedSchema.optional(),
	});

export type ToolEnvelope<TData> = {
	data: TData;
	evidence: EvidenceId[];
	asOf: string;
	truncated?: z.infer<typeof truncatedSchema>;
};
